import { JobStatus } from "namirasoft-job-arranger";

export class JobStatusObject
{
    static BlackList: JobStatusObject = new JobStatusObject(JobStatus.BlackList, "#90A4AE", "#fff", "Job or company you've excluded and don't intend to apply to.");
    static WhiteList: JobStatusObject = new JobStatusObject(JobStatus.WhiteList, "#90CAF9", "#fff", "Job you've shortlisted as interesting to apply to later.");
    static Applied: JobStatusObject = new JobStatusObject(JobStatus.Applied, "#4FC3F7", "#fff", "You've submitted an application and are waiting for a response.");
    static Replied: JobStatusObject = new JobStatusObject(JobStatus.Replied, "#FFF176", "#141B5C", "The company responded to your application.");
    static InterviewBooked: JobStatusObject = new JobStatusObject(JobStatus.InterviewBooked, "#CE93D8", "#fff", "An interview has been scheduled for this job.");
    static Interviewed: JobStatusObject = new JobStatusObject(JobStatus.Interviewed, "#A5D6A7", "#141B5C", "You've had at least one interview for this job.");
    static Offered: JobStatusObject = new JobStatusObject(JobStatus.Offered, "#AED581", "#141B5C", "You received a formal offer for this job.");
    static NotResponded: JobStatusObject = new JobStatusObject(JobStatus.NotResponded, "#FF8A65", "#fff", "The company never responded to your application.");
    static Rejected: JobStatusObject = new JobStatusObject(JobStatus.Rejected, "#EF9A9A", "#fff", "Your application was turned down.");
    static Hired: JobStatusObject = new JobStatusObject(JobStatus.Hired, "#4DB6AC", "#fff", "You received an offer and were hired for this job.");

    name: JobStatus;
    color: string;
    textColor: string;
    description: string;

    constructor(name: JobStatus, color: string, textColor: string, description: string)
    {
        this.name = name;
        this.color = color;
        this.textColor = textColor;
        this.description = description;
    }

    static get(name: string | null): JobStatusObject | null
    {
        if (name)
        {
            let all = this.getAll();
            for (let status of all)
                if (status.name === name)
                    return status;
        }
        return null;
    }

    static getAll(): JobStatusObject[] 
    {
        return [
            JobStatusObject.BlackList,
            JobStatusObject.WhiteList,
            JobStatusObject.Applied,
            JobStatusObject.Replied,
            JobStatusObject.InterviewBooked,
            JobStatusObject.Interviewed,
            JobStatusObject.Offered,
            JobStatusObject.NotResponded,
            JobStatusObject.Rejected,
            JobStatusObject.Hired
        ];
    }
}